export default "__VITE_ASSET__qroVHVDj__"